import { render, staticRenderFns } from "./webAICase.vue?vue&type=template&id=eb1a86c6&scoped=true&"
import script from "./webAICase.vue?vue&type=script&lang=js&"
export * from "./webAICase.vue?vue&type=script&lang=js&"
import style0 from "./webAICase.vue?vue&type=style&index=0&id=eb1a86c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1a86c6",
  null
  
)

export default component.exports